module.exports = __webpack_public_path__ + "img/I-BOS-1101-0.565bb589.png";